import React from 'react';
import { Ticket01 } from '@opendate-app/setlist';

function VenuePurchasesCard({ venues = [] }) {
  return (
    <div className="cdp-card">
      <h2 className="cdp-card-title">Venue Purchases</h2>

      {venues.length === 0 ? (
        <div className="cdp-field-value">No venue purchases yet</div>
      ) : (
        <ul className="cdp-venue-list">
          {venues.map((venue) => (
            <li key={venue.id} className="cdp-venue-list-item">
              <Ticket01 width={16} height={16} className="cdp-venue-list-icon" aria-hidden="true" />
              <span>{venue.name}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default VenuePurchasesCard;
